import { useRef } from 'react'

import { useSelector } from 'react-redux'

import type { MenuRecipesState, Recipe, RecipeUUID } from 'reducers/menu-recipes/recipes'
import { getRecipe } from 'selectors/menu-recipes/getRecipe'

/**
 * Returns recipes by ids that are offered in the currently selected menu (for a currently selected number of portions)
 */
export const useRecipes = (ids: (RecipeUUID | null)[]): (Recipe | null)[] =>
  useSelector((state: MenuRecipesState) => ids.map((id) => (id ? getRecipe(id)(state) : null)))

/**
 * Compared to useRecipes, this hook will only return a new array if the recipes have changed
 */
export const useRecipesImmutable = (ids: (RecipeUUID | null)[]): (Recipe | null)[] => {
  const recipes = useRecipes(ids)

  const recipesRef = useRef(recipes)
  const recipesMatch =
    recipes.length === recipesRef.current.length &&
    recipes.every((recipe, i) => recipe === recipesRef.current[i])

  if (!recipesMatch) {
    recipesRef.current = recipes
  }

  return recipesRef.current
}
